<template>
    <div id="error404">
        <div class="container">
            <h1 style="text-align:center;">Error 404</h1>
        </div>
    </div>
</template>
<script>
export default{
    name: 'error404',
}
</script>